export default {
    LOAD_COMPANIES (state, companies) {
        state.items = companies
    }
}